module.exports = __webpack_public_path__ + "static/media/add-card.c166a5b7.png";